import { ArithmeticHelper } from '@helpers/arithmetic.helper';

export interface DeclarableCapitalIncomesJson {
  id?: number;
  firstname?: string;
  lastname?: string;
  tax_residence?: string;
  pfu?: boolean;
  social_security_contribution?: boolean;
  self_employed_regime?: boolean;
  stock_savings_plan?: boolean;
  current_account_average?: number;
  tax_base?: number;
  cca_interest?: number;
  gross_dividends?: number;
  statutory_or_conventional_rate?: number;
  statutory_or_conventional_amount?: number;
  social_security_contribution_amount?: number;
  self_employed_regime_amount?: number;
  net_income?: number;
  withholding_tax?: number;
  status?: string;
  shares_number?: number;
  capital_contribution?: number;
  statutory_or_conventional_base?: number;
  social_security_contribution_base?: number;
  ten_percent_tax_exemption?: number;
}

export class DeclarableCapitalIncomes {
  constructor(
    public id?: number,
    public firstname?: string,
    public lastname?: string,
    public taxResidence?: string,
    public pfu?: boolean,
    public socialSecurityContribution?: boolean,
    public selfEmployedRegime?: boolean,
    public stockSavingsPlan?: boolean,
    public currentAccountAverage?: number,
    public taxBase?: number,
    public ccaInterest?: number,
    public grossDividends?: number,
    public statutoryOrConventionalRate?: number,
    public statutoryOrConventionalAmount?: number,
    public socialSecurityContributionAmount?: number,
    public selfEmployedRegimeAmount?: number,
    public netIncome?: number,
    public withHoldingTax?: number,
    public status?: string,
    public sharesNumber?: number,
    public capitalContribution?: number,
    public statutoryOrConventionalBase?: number,
    public socialSecurityContributionBase?: number,
    public tenPercentTaxExemption?: number
  ) {}

  static fromJson(json: Partial<DeclarableCapitalIncomesJson>): DeclarableCapitalIncomes {
    return new DeclarableCapitalIncomes(
      json.id,
      json.firstname,
      json.lastname,
      json.tax_residence,
      json.pfu,
      json.social_security_contribution,
      json.self_employed_regime,
      json.stock_savings_plan,
      json.current_account_average,
      json.tax_base,
      json.cca_interest,
      json.gross_dividends,
      json.statutory_or_conventional_rate,
      json.statutory_or_conventional_amount,
      json.social_security_contribution_amount,
      json.self_employed_regime_amount,
      json.net_income,
      json.withholding_tax,
      json.status,
      json.shares_number,
      json.capital_contribution,
      json.statutory_or_conventional_base,
      json.social_security_contribution_base,
      json.ten_percent_tax_exemption
    );
  }

  static toJson(declarableCapitalIncomes: DeclarableCapitalIncomes): DeclarableCapitalIncomesJson {
    return {
      id: declarableCapitalIncomes.id,
      firstname: declarableCapitalIncomes.firstname,
      lastname: declarableCapitalIncomes.lastname,
      tax_residence: declarableCapitalIncomes.taxResidence,
      pfu: declarableCapitalIncomes.pfu,
      social_security_contribution: declarableCapitalIncomes.socialSecurityContribution,
      self_employed_regime: declarableCapitalIncomes.selfEmployedRegime,
      stock_savings_plan: declarableCapitalIncomes.stockSavingsPlan,
      current_account_average: declarableCapitalIncomes.currentAccountAverage,
      tax_base: declarableCapitalIncomes.taxBase ? ArithmeticHelper.round(declarableCapitalIncomes.taxBase, 0) : null,
      cca_interest: declarableCapitalIncomes.ccaInterest
        ? ArithmeticHelper.round(declarableCapitalIncomes.ccaInterest, 0)
        : null,
      gross_dividends: declarableCapitalIncomes.grossDividends
        ? ArithmeticHelper.round(declarableCapitalIncomes.grossDividends, 0)
        : null,
      statutory_or_conventional_rate: declarableCapitalIncomes.statutoryOrConventionalRate,
      statutory_or_conventional_amount: declarableCapitalIncomes.statutoryOrConventionalAmount
        ? ArithmeticHelper.round(declarableCapitalIncomes.statutoryOrConventionalAmount, 0)
        : null,
      social_security_contribution_amount: declarableCapitalIncomes.socialSecurityContributionAmount
        ? ArithmeticHelper.round(declarableCapitalIncomes.socialSecurityContributionAmount, 0)
        : null,
      self_employed_regime_amount: declarableCapitalIncomes.selfEmployedRegimeAmount
        ? ArithmeticHelper.round(declarableCapitalIncomes.selfEmployedRegimeAmount, 0)
        : null,
      net_income: declarableCapitalIncomes.netIncome
        ? ArithmeticHelper.round(declarableCapitalIncomes.netIncome, 0)
        : null,
      withholding_tax: declarableCapitalIncomes.withHoldingTax
        ? ArithmeticHelper.round(declarableCapitalIncomes.withHoldingTax, 0)
        : null,
      status: declarableCapitalIncomes.status,
      shares_number: declarableCapitalIncomes.sharesNumber,
      capital_contribution: declarableCapitalIncomes.capitalContribution,
      statutory_or_conventional_base: declarableCapitalIncomes.statutoryOrConventionalBase,
      social_security_contribution_base: declarableCapitalIncomes.socialSecurityContributionBase,
      ten_percent_tax_exemption: declarableCapitalIncomes.tenPercentTaxExemption
    };
  }

  static toCalculationJson(declarableCapitalIncomes: DeclarableCapitalIncomes): Partial<DeclarableCapitalIncomesJson> {
    return {
      tax_residence: declarableCapitalIncomes.taxResidence,
      pfu: declarableCapitalIncomes.pfu,
      social_security_contribution: declarableCapitalIncomes.socialSecurityContribution,
      self_employed_regime: declarableCapitalIncomes.selfEmployedRegime,
      stock_savings_plan: declarableCapitalIncomes.stockSavingsPlan,
      current_account_average: declarableCapitalIncomes.currentAccountAverage,
      cca_interest: declarableCapitalIncomes.ccaInterest,
      gross_dividends: declarableCapitalIncomes.grossDividends,
      statutory_or_conventional_rate: declarableCapitalIncomes.statutoryOrConventionalRate,
      shares_number: declarableCapitalIncomes.sharesNumber,
      capital_contribution: declarableCapitalIncomes.capitalContribution,
      statutory_or_conventional_base: declarableCapitalIncomes.statutoryOrConventionalBase,
      social_security_contribution_base: declarableCapitalIncomes.socialSecurityContributionBase,
      ten_percent_tax_exemption: declarableCapitalIncomes.tenPercentTaxExemption
    };
  }
}
